import "./intro.css";

import { FaAward } from "react-icons/fa";
import React from "react";
import { VscFolderLibrary } from "react-icons/vsc";
import img from '../../assets/me1.png'

// import ME from '../../assets/Rasif Tagizade image.jpg';


const Intro = () => {
  return (
    <section id="about">
      <h5>Get to know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={img} alt="Rasif Taghizade" />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small></small>
            </article>
            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Projects</h5>
              <small>10+ Completed Projects</small>
            </article>
          </div>
          <p>
          I am Computer Science undergraduate from Indian Institute of Information Technology, Agartala
          As a Full-Stack developer, I enjoy tackling new challenges and continuously expanding my skillset.
          I am proficient in Javascript, as well as have knowledge in programming languages such as C++, Java, Python, Linux, GraphQL.
          I have a passion for working with Node.js, MongoDB, SQL, Tensorflow, MediaPipe. and modern Javascript libraries and frameworks  like React.js and Next.js.
          I am also interested in building new Web Technologies and Products, as well as exploring areas related to Artificial Intelligence and Machine Learning.
          </p>
          <a href="#contact" className="btn btn-primary">
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
};

export default Intro;
